// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2XVj8","label":"Completed_label__5inB-"};